import { __decorate } from "tslib";
import { injectable } from 'inversify';
let Image2CodeService = class Image2CodeService {
    constructor() {
        this.code = '';
        this.updateCb = () => { };
        this.finishCb = () => { };
    }
    file2Base64(file) {
        const reader = new FileReader();
        return new Promise((resolve) => {
            reader.readAsDataURL(file);
            reader.onload = function () {
                const result = this.result;
                resolve(result);
            };
        });
    }
    onUpdate(cb) {
        this.updateCb = cb;
    }
    onFinish(cb) {
        this.finishCb = cb;
    }
    getCode() {
        return this.code;
    }
    makeChatParam(url, key, imgStr, model = 'gpt-4o') {
        return {
            codeGenerationModel: model,
            editorTheme: 'cobalt',
            generatedCodeConfig: 'html_css',
            generationType: 'create',
            image: imgStr,
            history: [],
            inputMode: 'image',
            isImageGenerationEnabled: true,
            isTermOfServiceAccepted: false,
            openAiApiKey: key,
            openAiBaseURL: url,
        };
    }
    updateCode(str) {
        this.code = str;
        this.updateCb(this.code.replace(/^```html/, '').replace(/```\n$/, ''));
    }
    stop() {
        this.sock?.close?.();
    }
    async start(url, key, imageFile, model) {
        this.code = '';
        const base64 = await this.file2Base64(imageFile);
        const params = this.makeChatParam(url, key, base64, model);
        this.sock = new WebSocket('wss://qa-station-service.patsnap.info/screenshot2code-api/generate-code');
        this.sock.onopen = () => {
            this.sock.send(JSON.stringify(params));
        };
        this.sock.onmessage = (event) => {
            console.log(event.data);
            let res = null;
            try {
                res = JSON.parse(event.data);
                if (res.type === 'chunk') {
                    this.updateCode(this.code + res.value);
                }
                if (res.type === 'setCode') {
                    this.updateCode(res.value);
                    this.finishCb(this.code);
                }
            }
            catch (e) {
                console.log('error', e);
            }
        };
        this.sock.onclose = () => {
            console.log('close');
        };
        this.sock.onerror = (event) => {
            console.log('error', event);
        };
    }
};
Image2CodeService = __decorate([
    injectable()
], Image2CodeService);
export { Image2CodeService };
